import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map } from 'rxjs';
import { ToastModule } from 'primeng/toast';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, HeaderComponent, FooterComponent],
  template: `
    <div class="flex min-h-screen flex-col">
      <!-- O portal do administrador geral tem a sua própria barra -->
      @if (!inSuperAdmin()) {
        <app-header class="print:hidden" />
      }
      <main class="flex-1">
        <router-outlet />
      </main>
      @if (!inSuperAdmin()) {
        <app-footer class="print:hidden" />
      }
    </div>
    <p-toast position="top-right" styleClass="print:hidden" />
  `
})
export class AppComponent {
  private router = inject(Router);

  inSuperAdmin = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.router.url.startsWith('/super-admin'))
    ),
    { initialValue: location.pathname.startsWith('/super-admin') }
  );
}
